import { marketingUrl } from "@/lib/appLink";

/* The pair of links to the Terms of Service and the Privacy Policy.
 *
 * Both the login page and the acceptance gate name the same two documents, and
 * both were carrying the same twenty lines of anchor markup: two URLs, two
 * focus rings, and the note that they open in a new tab. Kept here so the
 * wording and the new-tab warning cannot drift between the place consent is
 * mentioned and the place it is given.
 *
 * Renders inline, as the tail of a sentence the caller writes. */
const linkCls =
  "text-[#16324F] underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#16324F] rounded-sm";

export const LegalLinks = () => (
  <>
    <a
      href={marketingUrl("/terms")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="terms-link"
      className={linkCls}
    >
      Terms of Service
    </a>{" "}
    and the{" "}
    <a
      href={marketingUrl("/privacy")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="privacy-link"
      className={linkCls}
    >
      Privacy Policy
    </a>
    <span className="sr-only"> (each opens in a new tab)</span>
  </>
);
